<template>
  <div>
    <b-card no-body class="mb-0">
      <div class="m-2">
        <b-row>
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <h3>Affichage de l'article : {{ article.codearticle }}</h3>
          </b-col>
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-end mb-1 mb-md-0">
            <router-link :to="{ name: 'listarticle' }" class="btn btn-primary" style="margin-bottom: 20px;">
              Retour
            </router-link>
          </b-col>
        </b-row>

        <!-- Détails produit -->
        <b-row align-v="start">
          <b-col cols="12" md="6" class="align-items-left justify-content-start mb-2 mb-md-0">
            <!-- <a :href=this.image data-lightbox="image" :data-title=article.codearticle >
              <img :src=this.image width="auto" height="auto" style="max-height: 280px; max-width: 100%;"/>
            </a> -->

            <div id="images">
              <div class="bloc1" v-if="this.image0">
                <a id="crop" :href=this.image0 data-lightbox="image" :data-title=article.codearticle>
                  <img :src=this.image0 />
                </a>
              </div>
              <div class="bloc2" v-if="this.image1">
                <a id="crop2" :href=this.image1 data-lightbox="image" :data-title=article.codearticle>
                  <img :src=this.image1 />
                </a>
              </div>
              <div class="bloc3" v-if="this.image2">
                <a id="crop2" :href=this.image2 data-lightbox="image" :data-title=article.codearticle>
                  <img :src=this.image2 />
                </a>
              </div>
              <div class="bloc4" v-if="this.image3">
                <a id="crop2" :href=this.image3 data-lightbox="image" :data-title=article.codearticle>
                  <img :src=this.image3 />
                </a>
              </div>
              <div class="bloc5" v-if="this.image4">
                <a id="crop2" :href=this.image4 data-lightbox="image" :data-title=article.codearticle>
                  <img :src=this.image4 />
                </a>
              </div>
            </div>

          </b-col>
          <b-col cols="12" md="6" class="align-items-left justify-content-end mb-2 mb-md-0">
            <b-card-text style="font-size: 18px"><strong>Collection :</strong> {{ categorie }} </b-card-text>
            <b-card-text style="font-size: 18px"><strong>Marque :</strong> {{ fournisseur }} </b-card-text>
            <!-- <b-card-text><strong>Code article :</strong> {{ article.codearticle }} </b-card-text> -->
            <b-card-text><strong>Nom :</strong> {{ article.nom }} </b-card-text>
            <b-card-text><strong>Description :</strong> <span
                style="min-height: 200px; padding: 10px; display: block; background-color: #fff; border: 1px solid #d8d6de; border-radius: 0.357rem;"
                v-html="article.description"> </span></b-card-text>
            <b-card-text></b-card-text>
            <b-card-text class="mt-5" v-if="commercial.showprice == true || commercial.showprice == 'true'"><strong>Prix
                HT :</strong> {{ parseFloat(article.prix).toFixed(2) }} {{ setting.devise }}</b-card-text>
            <b-card-text v-if="commercial.showprice == true"><strong>Prix TTC :</strong> {{ parseFloat(article.prix +
              (article.prix * (article.tva / 100))).toFixed(2) }} {{ setting.devise }}</b-card-text>
            <b-card-text v-if="commercial.showprice == true"><strong>TVA :</strong> {{ article.tva }} %</b-card-text>
            <b-card-text v-if="article.gammes"><strong>Gammes :</strong>
              <ul v-for="(gamme, gammeindex) in article.gammes" :key="gammeindex">
               <li>
                 Taille: {{ gamme.libelle }}
                 <template v-if="gamme.prix !== null && gamme.prix !== undefined && gamme.prix !== ''">
                   / Prix : ({{ gamme.prix }} €)
                 </template>
                 <span v-if="gammeindex != article.gammes.length - 1"></span>
               </li>
              </ul>
            </b-card-text>
          </b-col>
        </b-row>

        <!-- Tableau Variantes -->
        <b-row v-if="article.variants">
          <b-col cols="12" class="mt-4">
            <h4>Variantes de produits</h4>
            <b-table id="datatables" class="mt-1 mb-4" :items="article.variants" :fields="fields" stacked="md"
              :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection" striped small>
              <!-- IMAGES -->
              <template #cell(image)="data">
                <img :src=data.value height="90" width="auto" />
              </template>

              <!-- PRIX -->
              <template #cell(prix)="data">
                <span>{{ parseFloat(data.value).toFixed(2) }} {{ setting.devise }} HT </span><br />
                <span style="font-size: 0.8em;">{{ parseFloat(data.value + (data.value * (data.item.tva
              / 100))).toFixed(2) }} {{ setting.devise }} TTC</span>
              </template>

              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  :to="{ name: 'viewarticle', params: { id: data.item.key } }" variant="flat-success"
                  class="btn-icon rounded-circle">
                  <feather-icon icon="EyeIcon" />
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>

      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BTabs,
  BTab,
  BLink,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'

import "jquery/dist/jquery.min.js"
import "lightbox2/dist/css/lightbox.min.css"
import "lightbox2/dist/js/lightbox.min.js"
import moment from 'moment'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BTabs,
    BTab,
    BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BImg,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: [
        // { key: 'image', label: '', thStyle: { width: '160px' }, class: 'attachments' },
        { key: 'codearticle', label: 'Code article', sortable: true },
        { key: 'libelle', label: 'Nom', sortable: true },
        //{ key: 'realstock', label: 'Stock réel', sortable: true, class: 'text-center' },
        //{ key: 'virtualstock', label: 'Stock virtuel', sortable: true, class: 'text-center' },
      ],
      article: [],
      categorie: '',
      fournisseur: '',
      setting: JSON.parse(localStorage.setting),
      image0: '',
      image1: '',
      image2: '',
      image3: '',
      image4: '',
      perPage: 5,
      currentPage: 1,
      totalRows: 1,
      currentPage: 1,
      pageOptions: [5, 10, 25, 50, 100],
      filter: null,
      outlined: true,
      filterOn: ['libelle', 'email'],
      sortBy: 'codearticle',
      sortDirection: 'asc',
      sortDesc: false,
      localDB: new PouchDB(localStorage.getItem('database')),
      remoteDB: new PouchDB(localStorage.getItem('url') + '/' + localStorage.getItem('database')),
      commercial: JSON.parse(localStorage.commercial)
    }
  },
  computed: {
    /**
      * Total no. of records
      */
    rows() {
      return this.items.length
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  created() {
    // this.localDB.sync(this.remoteDB, { live: true, retry: true })

    this.localDB.get(this.$route.params.id, this.setArticles)
  },
  customButtons: {
    default: true,
  },
  methods: {
    async setArticles(err, doc) {
      if (err) {
        console.log('err', err)
      }
      console.log('doc', doc)
      this.article = doc

      await this.localDB.find({ selector: { type: 'categoriesarticles', id: doc.categorie } }, (err, doc) => {
        if (err) {
          console.log('err', err)
        } else {
          this.categorie = doc.docs[0].nom
        }
      })

      await this.localDB.find({ selector: { type: 'fournisseurs', id: doc.fournisseur } }, (err, doc) => {
        if (err) {
          console.log('err', err)
        } else {
          this.fournisseur = doc.docs[0].nom
        }
      })

      if (!doc._attachments) {
        // console.log('no attachement')
        this.image0 = require('@/assets/images/emptyimg.png')
      } else {
        // await this.localDB.getAttachment(doc._id, Object.keys(doc._attachments)[0]).then((blobOrBuffer) => {
        await this.localDB.getAttachment(doc._id, Object.keys(doc._attachments)[0]).then((blobOrBuffer) => {
          // console.log('url', Object.keys(doc._attachments)[0])           
          this.image0 = URL.createObjectURL(blobOrBuffer)
        });
        await this.localDB.getAttachment(doc._id, Object.keys(doc._attachments)[1]).then((blobOrBuffer) => {
          // console.log('url', URL.createObjectURL(blobOrBuffer))           
          this.image1 = URL.createObjectURL(blobOrBuffer)
        });
        await this.localDB.getAttachment(doc._id, Object.keys(doc._attachments)[2]).then((blobOrBuffer) => {
          // console.log('url', URL.createObjectURL(blobOrBuffer))           
          this.image2 = URL.createObjectURL(blobOrBuffer)
        });
        await this.localDB.getAttachment(doc._id, Object.keys(doc._attachments)[3]).then((blobOrBuffer) => {
          // console.log('url', URL.createObjectURL(blobOrBuffer))           
          this.image3 = URL.createObjectURL(blobOrBuffer)
        });
        await this.localDB.getAttachment(doc._id, Object.keys(doc._attachments)[4]).then((blobOrBuffer) => {
          // console.log('url', URL.createObjectURL(blobOrBuffer))           
          this.image4 = URL.createObjectURL(blobOrBuffer)
        });
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style>
.lb-nav a.lb-next,
.lb-nav a.lb-prev {
  opacity: 1;
}

.btn-primary {
  margin-right: 12px;
}

.per-page-selector {
  width: 90px;
}

.btNopadding button {
  padding: 0;
}

@media (max-width: 767.98px) {
  .table.b-table.b-table-stacked-md>tbody>tr>[data-label]::before {
    text-align: left;
  }
}
</style>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>


<style>
#images {
  display: grid;
  grid-auto-rows: minmax(100px, auto);
  max-width: 320px;
  height: auto;
}

.bloc1 {
  grid-column: 1 / 5;
  grid-row: 1;
}

.bloc2 {
  grid-column: 1;
  grid-row: 2;
}

.bloc3 {
  grid-column: 2;
  grid-row: 2;
}

.bloc4 {
  grid-column: 3;
  grid-row: 2;
}

.bloc4 {
  grid-column: 4;
  grid-row: 2;
}

#crop img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

#crop2 img {
  padding: 15px;
  width: 100%;
  height: auto;
  object-fit: cover;
}
</style>